export const calculateTax = (amount, taxRateInPercentage, TaxType) => {
  let calculatedTax = 0
  if (TaxType === 1) { //Inclusive
    calculatedTax = parseFloat(amount) - (parseFloat(amount) * (100 / (100 + parseFloat(taxRateInPercentage))))
    // calculatedTax = parseFloat(amount) - parseFloat(calculatedTax);

  } else if (TaxType === 2) { //Exclusive
    calculatedTax = (parseFloat(amount) * parseFloat(taxRateInPercentage)) / 100
  }
  return parseFloat(calculatedTax)
}

export const parser = (str) => {

  return JSON.parse(Array.isArray(str) ? JSON.stringify(str).replace(/\\/g, '') : str.replace(/\\/g, ''))

}

export const indianFormattedPrice = (val) => {

  const value = String(val)

  let removedValue = ''
  let finalVal = ''
  if (value.includes('.')) {
    removedValue = value.slice(value.indexOf('.'))
    finalVal = value.replace(removedValue, '')
    finalVal = finalVal.toString()
  } else {
    finalVal = value.toString()
  }
  let lastThree = finalVal.substring(finalVal.length - 3)
  const otherNumbers = finalVal.substring(0, finalVal.length - 3)
  if (otherNumbers !== '') lastThree = `,${lastThree}`
  const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree
  return res + (removedValue === '' ? '.00' : `.${removedValue.toString().split('.')[1]}`)
}

const paymentstatusObj = [
  { id: '', name: "Select All" },
  { id: '4', name: "Draft" },
  { id: '5', name: "Pending", color: 'light-danger' },
  { id: '6', name: "Partially Paid", color: 'light-warning' },
  { id: '7', name: 'Paid', color: 'light-success' },
  { id: '11', name: 'Sent', color: 'light-secondary' },
  { id: '12', name: 'Write Off', color: 'light-warning' }
]

export const renderStatus = (val) => {
  const obj = paymentstatusObj.find((o) => parseInt(o.id) === parseInt(val))
  return obj
}

const taskstatusObj = [
  { id: '', name: "Select All" },
  { id: '1', name: "Pending", color: 'light-primary' },
  { id: '2', name: "Inprogress", color: 'light-warning' },
  { id: '3', name: "Completed", color: 'light-success' },
  { id: '4', name: 'On Hold', color: 'light-secondary' },
  { id: '5', name: 'Cancelled', color: 'light-secondary' },
  { id: '6', name: 'Sent for Review', color: 'light-ocean' },
  { id: '7', name: 'Request Changes', color: 'light-info' },
  { id: '8', name: 'To Do', color: 'light-ocean' },
  { id: '9', name: 'Over Due', color: 'light-danger' }
]

export const renderTaskStatus = (val) => {
  const obj = taskstatusObj.find((o) => parseInt(o.id) === parseInt(val))
  return obj
}